export const FETCH_HOME_SUCCESS = 'home/fetchDataSuccess';
export const FETCH_HOME_ERROR = 'home/fetchDataError';
